import React, { useEffect, useState } from 'react';
import ConfirmOrder from './ConfirmOrder';
import Success from './Success';
import Fail from './Fail';
import { Container, ActionsContainer, Footer, FooterContainer } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { finishOrder } from '../../../../store/ducks/long-steel-shopping-cart/actions';
import LoadingFinishModal from '../../../../components/LoadingFinishModal';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
import jsPDF from 'jspdf';
import { EPurchaseRoutes } from '../../purchase.routes';
import { EOrderSettingsRoutes } from '../OrderSettings/orderSettings.routes';
import { getTotalQuantity } from '../../../../utils/purchaseHelpers';
import { Button } from '@gerdau/hefesto/Button';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

const Checkout: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [orderInPDF, setOrderInPDF] = useState<any>(undefined);

  const taggingInfoPreviousScreen = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const onConfirmOrder = () => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:RevisarPedido`,
        page: document.location.pathname,
        event: 'click',
        itemName: 'button:confirmarEnviarParaAnalise',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_confirmarEnviarParaAnalise`,
        product: getProductsCode(),
        orderInfo: getOrderInfo()
      })
    );
    const { items, emitterId, receiverId, customerOrder } = shoppingCartState;
    dispatch(finishOrder(items, emitterId, receiverId, customerOrder));
  };

  const getProductsCode = (): string => {
    const productCode = shoppingCartState.items.map((i) => i.sku);
    return productCode.join();
  };

  const getOrderInfo = (): string => {
    return `#qtd:${shoppingCartState.items.length}#total:${getTotalQuantity(
      shoppingCartState.items
    )}`;
  };

  const goBackToShoppingCart = () => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:RevisarPedido`,
        page: document.location.pathname,
        event: 'click',
        itemName: 'button:voltarEAlterarPedido',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_revisarPedido_voltarEAlterarPedido`,
        product: getProductsCode()
      })
    );
    setOrderInPDF(undefined);
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${EOrderSettingsRoutes.SHOPPING_CART}`
    );
  };

  useEffect(() => {
    if (
      (shoppingCartState.items.length === 0 &&
        shoppingCartState.createdOrders?.length === 0) ||
      customersState.loading
    ) {
      history.push(`${ERoutes.PURCHASE}`);
    } else if (
      shoppingCartState.items.some(
        (item) =>
          item.itemSaleInfo === undefined ||
          !item.itemSaleInfo.unityMeasure ||
          !item.itemSaleInfo.quantity ||
          !item.itemSaleInfo.requiredDate ||
          !item.itemSaleInfo.term
      )
    ) {
      goBackToShoppingCart();
    }
  });

  const generatePDFFromConfirmOrderElement = (element: HTMLElement) => {
    const pdf = new jsPDF('p', 'pt', 'a4');
    pdf.html(element, {
      html2canvas: {
        scale: 0.45
      }
    });
    setTimeout(() => {
      // timeout para dar tempo de tirar o print e depois esconde o segundo ConfirmOrder que está sendo passado, pois ele serve somente para montar o PDF
      setOrderInPDF(pdf);
    }, 0);
  };

  return (
    <Container>
      {!shoppingCartState.finishOrderError &&
        shoppingCartState.createdOrders &&
        shoppingCartState.createdOrders.length < 1 && (
          <>
            <ConfirmOrder
              shoppingCartState={shoppingCartState}
              customersState={customersState}
            />

            <FooterContainer>
              <Footer>
                <div className="quantites">
                  <div>
                    <span>Quantidade de itens </span>
                    <strong>{shoppingCartState.items.length}</strong>
                  </div>
                  <div>
                    <span>Quantidade total </span>
                    <strong>
                      {getTotalQuantity(shoppingCartState.items)} t
                    </strong>
                  </div>
                </div>
                <ActionsContainer>
                  <div>
                    <Button
                      fullWidth
                      variant="secondary"
                      onClick={goBackToShoppingCart}
                      name={'Voltar e alterar pedido'}
                    >
                      Voltar e alterar pedido
                    </Button>

                    <Button
                      fullWidth
                      onClick={onConfirmOrder}
                      disabled={orderInPDF === undefined}
                      name={'Confirmar'}
                    >
                      Confirmar e enviar para análise
                    </Button>
                  </div>
                </ActionsContainer>
              </Footer>
            </FooterContainer>

            {/* Onde é feito o PDF da ordem */}
            {!orderInPDF && (
              <ConfirmOrder
                shoppingCartState={shoppingCartState}
                customersState={customersState}
                saveOrderInPDF={generatePDFFromConfirmOrderElement}
              />
            )}
          </>
        )}

      {shoppingCartState.finishOrderLoading &&
        !shoppingCartState.finishOrderError && (
          <LoadingFinishModal message="Aguarde, seu pedido está sendo enviado..." />
        )}

      {!shoppingCartState.finishOrderLoading &&
        !shoppingCartState.finishOrderError &&
        shoppingCartState.createdOrders &&
        shoppingCartState.createdOrders.length > 0 && (
          <Success orderInPDF={orderInPDF} />
        )}

      {!shoppingCartState.finishOrderLoading &&
        shoppingCartState.finishOrderError && (
          <Fail onTryAgainClick={onConfirmOrder} />
        )}
    </Container>
  );
};

export default Checkout;
